import axios, { AxiosResponse } from 'axios';

import {
  ISubmitPaymentLinkPayload,
  ISubmitPaymentLinkResponse,
  IValidatePaymentLinkResponse,
} from '../../modules/PaymentLink/v2/types/types';

export const BASE_PATH = process.env.REACT_APP_API_URL;

export const validatePaymentLinkV2 = async (
  link: string,
): Promise<AxiosResponse<IValidatePaymentLinkResponse>> => {
  return axios.post(`${BASE_PATH}/payment-link/validate-v2/${link}`);
};

export const submitPaymentLinkV2 = async (
  link: string,
  payload: ISubmitPaymentLinkPayload,
): Promise<AxiosResponse<ISubmitPaymentLinkResponse>> => {
  return axios.post(`${BASE_PATH}/payment-link/submit-v2/${link}`, payload);
};

export const validateEmail = async (email: string): Promise<AxiosResponse> => {
  return axios.post(`${BASE_PATH}/validate/email`, { email });
};

export const validateDocument = async (
  document: string,
): Promise<AxiosResponse> => {
  return axios.post(`${BASE_PATH}/validate/document`, { document });
};
